import React from 'react';

import { SVGIcon } from 'UIKit/index';
import Instareports from 'Assets/images/AppLogo/instareports.svg';

const backgroundStyle = {
    backgroundImage: 'url(' + Instareports + ')',
    backgroundSize: 'cover',
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center',
};
export default function DCInstareports(props) {
    return <SVGIcon {...props} viewBox="0 0 2000 2000" style={backgroundStyle} />;
}
